// extracted by mini-css-extract-plugin
module.exports = {"duration":"e7R1qF"};